import { takeEvery, put, call } from "redux-saga/effects";
import "whatwg-fetch";
import * as GlobalActions from "../../actions";
import * as Actions from "./store/actions";
import ActionTypes from "../../constants";
import * as Apis from "./apis";
import { wrapByLoader, wrapWithoutLoader } from "../../utils";

const fetchStewardBusinessPartnerLists = (
  action: Actions.fetchStewardBusinessPartnerListsActionType
) =>
  wrapByLoader(function*() {
    try {
      const response = yield call(
        Apis.fetchStewardBusinessPartnerListsApi,
        action.payload
      );
      if (!response.error) {
        const bpLists = response.data.businessPartner;
        const pageInfo = response.data.pageInfo;
        yield put(
          Actions.fetchStewardBusinessPartnerListsSucceeded(bpLists, pageInfo)
        );
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

export default [
  takeEvery(
    ActionTypes.FETCH_STEWARD_BUSINESSPARTNER_LISTS,
    fetchStewardBusinessPartnerLists
  ),
];
